// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1EKS8","additionalInfo":"AgreementModal_additionalInfo__2fxAi"};